import alphin from './alphin';
import deliverect from './deliverect';
import orderbird from './orderbird';
import sides from './sides';
import sumup from './sumup';

export default { alphin, deliverect, orderbird, sides, sumup };
